import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 * Use the raw response from the http repository to create a recommended ads list value object.
 */
export class FromRecommendedAdsRawDataToRecommendedAdsListVOMapper extends Mapper {
  constructor({
    config,
    fromAdRawDataToAdEntityMapper,
    recommendedAdsListValueObjectFactory,
    metadataRecommededAdsValueObject
  }) {
    super()
    // Config
    this._config = config
    // Mappers
    this._fromAdRawDataToAdEntityMapper = fromAdRawDataToAdEntityMapper
    // Value Objects
    this._recommendedAdsListValueObjectFactory = recommendedAdsListValueObjectFactory
    this._metadataRecommededAdsValueObject = metadataRecommededAdsValueObject
  }

  map = ({items = [], metadata = {}, recommendedAdsFallback}) => {
    const recommendedAdsList = items.map(this._fromAdRawDataToAdEntityMapper.map)
    const {listName, transactionId, queryParams} = metadata

    const metadataVO = this._metadataRecommededAdsValueObject({
      listName,
      itemId: queryParams?.itemId,
      recommendationId: transactionId,
      isEmpty: Boolean(!listName)
    })

    return this._recommendedAdsListValueObjectFactory({
      items: recommendedAdsList,
      metadata: metadataVO,
      isRecommendedAdsFallback: Boolean(recommendedAdsFallback)
    })
  }
}
